import React from 'react';
import { NumericTextBox } from '../../../../formikBindings';
import { IAnswerProps } from './types';

export const NumberAnswer: React.FC<IAnswerProps> = ({ name, enablestatus }) => (
    <NumericTextBox name={name} format="0.##" enabled={enablestatus} />
);
